module.exports = __webpack_public_path__ + "cheer.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/cheer.mp3
// module id = 665
// module chunks = 0